import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/components/layout";

import { setDocumentTitle } from "@/utils/util";
const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const routes = [
  // {
  //   path: "/login",
  //   name: "Login",
  //   // redirect: "/user-center",
  //   component: () => import("@/views/login"),
  // },
  // {
  //   path: '/change-phone',
  //   name: 'ReBindPhone',
  //   component: () => import('@/views/options/reBind')
  // },
  // {
  //   path: '/ban-query',
  //   name: 'BanQuery',
  //   component: () => import('@/views/options/banQuery')
  // },
  // {
  //   path: '/props-flow',
  //   name: 'PropsFlow',
  //   component: () => import('@/views/options/propsFlow')
  // },
  {
    path: "/",
    name: "Layout",
    redirect: "/select-game",
    component: Layout,
    children: [
      {
        path: "/login",
        name: "Login",
        // redirect: "/user-center",
        component: () => import("@/views/userCenter"),
      },
      {
        path: "/user-center",
        name: "UserCenter",
        component: () => import("@/views/userCenter"),
        meta: {
          // keepAlive: true,
        },
      },
      {
        path: "/im",
        name: "Im",
        redirect: "/msg-board",
        component: () => import("@/views/im/index"),
        meta: {
          // keepAlive:true
        },
        children: [
          {
            path: "/msg-board",
            name: "ImMsgBoard",
            component: () => import("@/views/im/modules/messageBoard"),
            meta: {
              // keepAlive:true
            },
          },
          {
            path: "/im-chat",
            name: "ImChat",
            component: () => import("@/views/im/modules/im"),
            meta: {
              // keepAlive:true
            },
          },
        ],
      },
      {
        path: "/bind-roles",
        name: "BindRoles",
        component: () => import("@/views/bindRoles"),
      },
      {
        path: "/report",
        name: "Report",
        component: () => import("@/views/report/index"),
      },
      {
        path: "/report-result",
        name: "ReportResult",
        component: () => import("@/views/report/result"),
      },
      {
        path: "/report-history",
        name: "ReportHistory",
        component: () => import("@/views/report/history"),
      },
      {
        path: "/faq-detail/:id",
        name: "faqDetail",
        component: () => import("@/views/faqDetail"),
      },
      {
        path: "/change-phone",
        name: "ReBindPhone",
        component: () => import("@/views/options/reBind/index"),
      },
      {
        path: "/ban-query",
        name: "BanQuery",
        component: () => import("@/views/options/banQuery"),
      },
      {
        path: "/rebates-query",
        name: "RebatesQuery",
        component: () => import("@/views/options/rebatesQuery"),
      },
      {
        path: "/props-flow",
        name: "PropsFlow",
        component: () => import("@/views/options/propsFlow"),
      },
      {
        path: "/special-props-flow",
        name: "SpecialPropsFlow",
        component: () => import("@/views/options/specialPropsFlow"),
      },
      {
        path: "/account-info",
        name: "AccountInfo",
        component: () => import("@/views/options/accountInfo"),
      },
    ],
  },
  {
    path: "/public-report",
    name: "PublicReport",
    component: () => import("@/views/public/report.vue"),
  },
  {
    path: "/public-report-result",
    name: "PublicReportResult",
    component: () => import("@/views/public/result.vue"),
  },
  {
    path: "/select-game",
    name: "SelectGame",
    component: () => import("@/views/selectGame"),
  },
  {
    path: "/report-record",
    name: "ReportRecord",
    component: () => import("@/views/report/record"),
  },
  {
    path: "/wx-schema",
    name: "WxSchema",
    component: () => import("@/views/wxSchema"),
  },
  {
    path: "/red-envelope",
    name: "RedEnvelope",
    component: () => import("@/views/redEnvelope"),
  },
  {
    path: "/permission-query",
    name: "PermissionQuery",
    component: () => import("@/views/permissionQuery"),
  },
  // 未匹配到的跳转到首页
  {
    path: "*",
    redirect: "/user-center",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.NODE_ENV === "production" ? "kf2.0" : process.env.BASE_URL,
  routes,
});

// router.beforeEach((to, from, next) => {
//   if (to.name === 'ImMsgBoard') {
//     setDocumentTitle('玩家留言');
//   } else {
//     setDocumentTitle('客服中心');
//   }
//   next();
// });

export default router;
